import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';

type Parameters = {
	accountId: AccountId;
};

export async function deleteBannerDismissState({ accountId }: Parameters) {
	try {
		await performDeleteRequest(
			`/rest/api/3/user/properties/jsm-repackaging-banners-dismiss-state?accountId=${accountId}`,
		);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// https://data-portal.internal.atlassian.com/analytics/registry/71209
		fireErrorAnalytics({
			meta: {
				id: 'deleteBannerDismissState',
				packageName: 'jiraRouterResourcesJsmRepackagingBanner',
				teamName: 'jenga',
			},
			error,
		});
	}
}
